'use client';

import { c as _c } from "react/compiler-runtime";
import { cx } from '@7f-ui';
const WEEKDAY_LABELS = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];
type OpeningHoursWindow = {
  from: string;
  to: string;
};
type OpeningHoursDay = {
  date: string;
  weekday: number;
  closed: boolean;
  windows: OpeningHoursWindow[];
};
type AppExperienceOpeningHoursProps = {
  days: OpeningHoursDay[];
  highlightedDate?: string | null;
};
export function AppExperienceOpeningHours(t0) {
  const $ = _c(7);
  const {
    days,
    highlightedDate
  } = t0;
  if (days.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== days || $[1] !== highlightedDate) {
    let t2;
    if ($[3] !== highlightedDate) {
      t2 = day => {
        const isHighlighted = day.date === highlightedDate;
        return <tr key={day.date} className={cx("flex justify-between gap-4", isHighlighted && "font-bold")} data-testid={`OpeningHours.day.${day.weekday}`} aria-current={isHighlighted ? "date" : undefined}><td>{WEEKDAY_LABELS[day.weekday - 1] ?? ""}</td><td className="text-right"><OpeningHoursTimes day={day} /></td></tr>;
      };
      $[3] = highlightedDate;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = days.map(t2);
    $[0] = days;
    $[1] = highlightedDate;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <table className="w-full font-body-small"><tbody className="grid gap-2">{t1}</tbody></table>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function OpeningHoursTimes(t0) {
  const $ = _c(4);
  const {
    day
  } = t0;
  if (day.closed) {
    return "Geschlossen";
  }
  if (day.windows.length === 0) {
    return "Ge\xF6ffnet";
  }
  let t1;
  if ($[0] !== day.windows) {
    t1 = day.windows.map(_temp);
    $[0] = day.windows;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="grid gap-1">{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(window) {
  return <span key={`${window.from}-${window.to}`}>{`${window.from.slice(0, 5)} - ${window.to.slice(0, 5)} Uhr`}</span>;
}